// extracted by mini-css-extract-plugin
export var compactFilters = "_f6-4";
export var detailImage = "_f6-1";
export var dropdownContainer = "_f6-2";
export var imageContainer = "_f6-0";
export var selectedCard = "_f6-3";